import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { ContainerField, Label, Select, Option, Icon, MessageErrorBox, HelpText } from './style'
import inputProptypes from '@components/input/input-proptype'
import * as BaseFunctions from '../base-functions'

const Dropdownlist = ({
  // Identification Properties
  id,
  className,
  label,
  value,
  options,
  name,
  defaultText,

  // Event and State Properties
  onChange,
  onFocus,
  onBlur,
  disabled,
  loading,
  onFieldValidation,

  // Validate Properties
  errorMessage,
  helperText,
  required,
  requiredSymbol,
  requiredMessage,
  maxLength,
  selectRef,

  // Accessibility Properties
  tabIndex,

  // Theme Properties
  fixedLabel,
}) => {
  const [currentErrorMessage, setCurrentErrorMessage] = useState()
  const [_required, _setRequired] = useState(false)
  const [selectValue, setSelectValue] = useState(value || '')
  const [isLoading, setIsLoading] = useState(loading)

  const [currentName] = useState(BaseFunctions.getInputName(name))
  const messageRequired = requiredMessage || 'Campo obrigatório'
  const _requiredSymbol = requiredSymbol || '*'
  const currentCssClass = classNames('aberto', { ['required']: _required }, className)

  const validateRequiredField = value => {
    const hasError = true
    if (required && !value) {
      _setRequired(true)
      setCurrentErrorMessage(messageRequired)
      return hasError
    }
    return !hasError
  }

  const handleOnBlur = async ({ target: { value } }) => {
    await BaseFunctions.handlerOnFieldValidation(onFieldValidation, currentName, false)
    setCurrentErrorMessage('')
    _setRequired(false)

    let fieldNeedValidation = false
    fieldNeedValidation = validateRequiredField(value)
    if (fieldNeedValidation) await BaseFunctions.handlerOnFieldValidation(onFieldValidation, currentName, true)

    if (onBlur) onBlur(value)
  }

  const handleOnChange = ({ target: { value } }) => {
    if (onChange) {
      setIsLoading(true)
      Promise.resolve(onChange(value))
        .then(result => {
          if (!result) return
          if (value.length !== result.length) setSelectValue(result)
        })
        .finally(() => setIsLoading(false))
    }
  }

  const checkForErrorMessage = async () => {
    setCurrentErrorMessage('')
    await BaseFunctions.handlerOnFieldValidation(onFieldValidation, currentName, false)

    if (errorMessage) {
      setCurrentErrorMessage(errorMessage)
      await BaseFunctions.handlerOnFieldValidation(onFieldValidation, currentName, true)
    }
  }

  const containerProps = {
    isLoading,
    fixedLabel,
  }

  const selectProps = {
    id: id || currentName,
    value: selectValue,
    disabled,
    required,
    fixedLabel: true,
    tabindex: tabIndex || 0,

    onChange: handleOnChange,
    onFocus,
    onBlur: handleOnBlur,
    maxLength,
    name: currentName,
    ref: selectRef,
  }

  useEffect(() => {
    const runAsync = async () => {
      await checkForErrorMessage()
    }
    runAsync()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorMessage])

  useEffect(() => {
    const runAsync = async () => {
      await BaseFunctions.handlerOnFieldValidation(onFieldValidation, currentName, required)
    }
    runAsync()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setSelectValue(value || '')
  }, [value])

  useEffect(() => {
    setIsLoading(loading)
  }, [loading])
  return (
    <ContainerField key={id} className={currentCssClass} {...containerProps}>
      <Icon />
      <Select {...selectProps}>
        <Option value="">{defaultText || 'escolha'}</Option>
        {options &&
          options.map(item => (
            <Option key={`ddl_${item.id}`} value={item.id}>
              {item.name}
            </Option>
          ))}
      </Select>

      <Label htmlFor={id || currentName}>
        {label}
        {required && ` ${_requiredSymbol}`}
      </Label>

      {helperText && <HelpText>{helperText}</HelpText>}
      {currentErrorMessage && (
        <MessageErrorBox role="alert" id={`message-error-${id || currentName}`}>
          {currentErrorMessage}
        </MessageErrorBox>
      )}
    </ContainerField>
  )
}

Dropdownlist.propTypes = { ...inputProptypes, options: PropTypes.array.isRequired }

export default Dropdownlist
